import { getAuthenticatedBackendClient } from "./backend.api";

/** The generated fetch client decodes non-JSON responses as text. Keep CP1252 exports as bytes. */
export async function downloadDATEVExport(id: string): Promise<Blob> {
  const client = await getAuthenticatedBackendClient();
  const { BASE, TOKEN } = client.request.config;
  if (typeof TOKEN !== "string" || !TOKEN) throw new Error("Bitte melde dich erneut an.");
  const response = await fetch(`${BASE}/datev-export-runs/${encodeURIComponent(id)}/download/`, {
    method: "POST",
    headers: { Authorization: `Bearer ${TOKEN}` },
  });
  if (!response.ok) throw new Error(`DATEV-Download fehlgeschlagen (${response.status}).`);
  return response.blob();
}
